import React from 'react';
import './ViewMoreButton.css';
import { DownArrowIcon } from '../Icons/DownArrowIcon';
import { RightArrowIcon } from '../Icons/RightArrowIcon';

interface ViewMoreButtonProps {
  /** 按钮文本，默认为"查看更多" */
  text?: string;
  /** 图标类型，默认为 'down'（下箭头），'right' 为右箭头，传入 null 则不显示图标 */
  iconType?: 'down' | 'right' | null;
  /** 是否显示边框，默认为 true */
  showBorder?: boolean;
  /** 点击事件 */
  onClick?: () => void;
  /** 自定义类名 */
  className?: string;
}

/**
 * 通用"查看更多"按钮组件
 * 支持自定义文本和右侧图标
 * 默认显示下箭头，只有首页项目列表使用右箭头
 */
export const ViewMoreButton: React.FC<ViewMoreButtonProps> = ({
  text = '查看更多',
  iconType = 'down',
  showBorder = false,
  onClick,
  className = '',
}) => {
  // 根据 iconType 选择图标（使用 currentColor，随主题色变化）
  const getIcon = () => {
    if (iconType === null) return null;
    if (iconType === 'right') return <RightArrowIcon className="view-more-icon-svg" />;
    return <DownArrowIcon className="view-more-icon-svg" />;
  };

  const displayIcon = getIcon();

  return (
    <div className={`view-more-section ${className}`}>
      <button 
        className={`view-more-btn ${showBorder ? '' : 'view-more-btn-no-border'}`} 
        onClick={onClick}
      >
        <span className="view-more-text">{text}</span>
        {displayIcon && <span className="view-more-icon">{displayIcon}</span>}
      </button>
    </div>
  );
};

